import { EFM_DOMAIN_LABELS, EFMDomainCode } from 'src/features/domains/efmDomains';

export const DOCUMENT_TYPE_OPTIONS = [
  // Generic
  { value: 'contract', label: 'Contract' },
  { value: 'invoice', label: 'Invoice' },
  { value: 'order', label: 'Order' },
  { value: 'purchase_order', label: 'Purchase Order' },
  { value: 'receipt', label: 'Receipt' },
  { value: 'meeting_minutes', label: 'Meeting Minutes' },
  // Compliance
  { value: 'policy', label: 'Policy' },
  { value: 'sop', label: 'SOP' },
  { value: 'regulation', label: 'Regulation' },
  { value: 'authorising_engineer_report', label: 'Authorising Engineer Report' },
  { value: 'audit_report', label: 'Audit Report' },
  { value: 'other_report', label: 'Other Report' },
  { value: 'condition_survey', label: 'Condition Survey' },
  { value: 'risk_assessment', label: 'Risk Assessment' },
  { value: 'terms_of_reference', label: 'Terms of Reference' },
  { value: 'appointment_letter', label: 'Appointment Letter' },
  { value: 'training_certificate', label: 'Training Certificate' },
  { value: 'other_certificate', label: 'Other Certificate' },
  { value: 'tender_document', label: 'Tender Document' },
  { value: 'action_log', label: 'Action Log' },
  // Drawings & plans
  { value: 'site_plan', label: 'Site Plan' },
  { value: 'architectural_drawing', label: 'Architectural Drawing' },
  { value: 'engineering_drawing', label: 'Engineering Drawing' },
  { value: 'floor_plan', label: 'Floor Plan' },
  { value: 'schematic', label: 'Schematic' },
  { value: 'as_built_drawing', label: 'As-Built Drawing' },
  // Other
  { value: 'asset_photograph', label: 'Asset Photograph' },
  { value: 'email', label: 'Email' },
  { value: 'other', label: 'Other' }
];

export const DOMAIN_OPTIONS: { value: EFMDomainCode; label: string }[] = (
  Object.entries(EFM_DOMAIN_LABELS) as [EFMDomainCode, string][]
).map(([value, label]) => ({ value, label }));

const DOCUMENT_TYPE_LABEL: ReadonlyMap<string, string> = new Map(DOCUMENT_TYPE_OPTIONS.map((o) => [o.value, o.label]));

/** A slug as title-case words, for a value with no label of its own. */
export function humaniseSlug(slug: string): string {
  return slug.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** The label the Document Hub shows for a document type slug. */
export function documentTypeLabel(slug: string): string {
  return DOCUMENT_TYPE_LABEL.get(slug) ?? humaniseSlug(slug);
}
